import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useModal } from "../../context/ModalContext";
import { fetchApi, getAssetUrl } from "../../config";

export default function Hero() {
    const { openModal } = useModal();
    const [counters, setCounters] = useState([]);
    const widgetRef = useRef(null);

    useEffect(() => {
        const container = widgetRef.current;

        if (!container) return;

        // Prevent duplicate widget initialization
        if (container.dataset.loaded === "true") {
            return;
        }

        container.dataset.loaded = "true";

        const script = document.createElement("script");

        script.src = "https://upworkrank.com/w.js";
        script.async = true;

        script.setAttribute("data-agency", "647253485275017216");
        script.setAttribute("data-format", "badge");
        script.setAttribute("data-accent", "#f47a20");
        script.setAttribute("data-fields", "mrr,rating,jobs");

        container.appendChild(script);

        return () => {
            // Don't remove the widget during React StrictMode's
            // development-only effect cleanup.
        };
    }, []);

    useEffect(() => {
        let counters = true;
        async function load() {
            try {
                const res = await fetchApi("get_counters_info.php");
                if (!counters) return;
                if (res && Array.isArray(res.Info)) {
                    
                    setCounters(res.Info);
                }
            } catch (err) {
                // keep defaults on error
            }
        }
        load();
        return () => { counters = false; };
    }, []);

    return (
        <>
        <section className="container hero">
            <div>
                {/* <div
                    ref={widgetRef}
                    className="upworkrank-widget"
                ></div> */}
                <div className="eyebrow eyebrow--inline">
                    <span className="rule"></span>
                    Custom Solutions Development
                </div>
                <h1>Software built around the way you actually work.</h1>
                <p className="lead">Kudosta designs and engineers custom platforms, internal tools and web apps — no templates, no compromises. We turn the way your business runs into software that gives you an edge.</p>
                <div className="cta-row">
                    <button className="btn btn-primary" onClick={openModal} type="button">Start a project</button>
                    <Link className="btn btn-outline" to="/portfolio">See our work</Link>
                </div>
                <div className="rating kd-hidden">
                    <span className="stars">
                        <svg fill="currentColor" stroke="none" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg><svg fill="currentColor" stroke="none" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg><svg fill="currentColor" stroke="none" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg><svg fill="currentColor" stroke="none" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg><svg fill="currentColor" stroke="none" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                        </svg>
                    </span> 
                    Trusted by 40+ businesses across 6 countries
                </div>
            </div>
            {/* <div className="hero-art">
                <div className="stage">
                    <span className="glow"></span>
                    <span className="dots"></span>
                </div>
                <div className="panel">
                    <div className="dotsrow">
                        <span></span><span></span>
                        <span></span>
                    </div>
                    <div className="t">Operations dashboard</div>
                    <div className="s">Custom-built for your workflow</div>
                    <div className="bars">
                        <i className="hb-48"></i>
                        <i className="hb-70"></i>
                        <i className="hb-56"></i>
                        <i className="o hb-88"></i>
                        <i className="hb-64"></i>
                        <i className="n hb-100"></i>
                    </div>
                </div>
                <div className="badge-live">
                    <div className="row">
                        <span className="t">Automation live</span>
                        <span className="d"></span>
                    </div>
                    <div className="big">−12 hrs<small> / week</small></div>
                </div>
                <div className="badge-count">
                    <div className="big">
                        {counters.length > 0 ? `${counters[0].projects_shipped}+` : "120+"}
                    </div>
                    <div className="s">projects shipped</div>
                </div>
            </div> */}
            <div className="hero-art">
                <img src={getAssetUrl('kds-assets/img/kudosta-banner-art.svg')} alt="Kudosta Banner Art" />
            </div>
        </section>
        </>
    )
}